// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"524":"b7ac5060","566":"7787d385"}[chunkId] + ".chunk.js");